import { useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/lib/api/client';
import type { Site } from '@/lib/types';

/**
 * 현장 목록 — 현장관리에서 정한 차례(`sortOrder`) 그대로. front `useSites` 와 같은 규칙이다.
 *
 * 안전 서버의 현장 사본(`/v1/safe/lookup/sites` · DOC-141 §11-3)을 읽는다 — 라운지가 보내 준 명부라 접힌 현장 · 입찰은 빠져 온다.
 */
export function useSites(enabled = true) {
  return useQuery({
    enabled,
    queryKey: ['sites'] as const,
    queryFn: () => apiFetch<Site[]>('/v1/safe/lookup/sites'),
    select: (sites) => [...sites].sort((a, b) => a.sortOrder - b.sortOrder),
  });
}
